// Module
var code = "<modal-frame on-close=\"vm.dismissModal\" title=\"'Edit Category Type'\"><category-type-form categorizables=\"vm.categorizables\" category-type=\"vm.categoryType\" is-busy=\"vm.isSaving\" ng-if=\"!vm.isLoading\" on-save=\"vm.saveCategoryType\"></category-type-form></modal-frame>";
// Exports
module.exports = code;